import axios from 'axios';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form';
import { RenderInputWithDiv, RenderRadioCheckBox, RenderSelect } from '../../../component/formInput';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';

var _ = require('lodash');

function getServerIpType(productType) {
  switch(productType) {
    case "EMAIL": {
      return "SERVER_EMAIL"
    }
    case "LINUX_HOSTING" : {
      return "SERVER_CPANEL"
    }
    case "WINDOW_HOSTING" : {
      return "SERVER_PLESK"
    }
    default: {
      return "SERVER_VPS"
    } 
  }
}


const mapState = (state, props) => ({
  initialValues : props.ipProduct
});

const mapDispatch = dispatch => ({
    
});

const validate = (values) => {
  const errors = {};

  if(!values.new_ip_addon) {
    errors.new_ip_addon = "Vui lòng chọn IP mới";
  } 
  if(!values.modify_reason) {
    errors.modify_reason = "Vui lòng chọn lý do chuyển đổi";
  } 
  return errors;
}

// Form thay đổi IP của Addon dịch vụ
class AddonIPForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ip_addon_data: []
    }
  }

  // Lấy đúng danh sách IP
  getIsFreeIpList = () => {
    const self = this;
    axios({
      method: 'get',
      url: window.api_url + '/admin/api/is_free_ip/list',
      withCredentials: true
    }).then(function (response) {
      if(!response.data.isError) {
        self.setState({
          ip_addon_data: response.data.data
        })
      }
    });
  }

  componentDidMount() {
    this.getIsFreeIpList();
  }
  
  render() {
    const {handleSubmit, ipProduct, submitting, modalConfig, onSubmit, handleHideModal, onRemoveIp} = this.props;
    const { ip_addon_data } = this.state;
    const ip_options = _.map(ip_addon_data, (i) => ({label: i.ip, value: i.ip}))

    return (
      <React.Fragment>
        <ToastContainer />
        <Modal bsPrefix = "modal" {...modalConfig} dialogClassName="modal-open">
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-sm">Thay Đổi IP Addon</Modal.Title>
          </Modal.Header>
          <form>
            <Modal.Body>
              <span>
                IP Cũ: <strong>{ipProduct.ip_address}</strong>
                {ipProduct && ipProduct.product.product_type == "IP" && <span onClick={() => onRemoveIp(ipProduct.id)} style={{color:"red", cursor: 'pointer'}}> [Rút lại IP] </span>}
              </span>
              <Field name="new_ip_addon" placeholder="Chọn IP Addon mới..." options={ip_options} component={RenderSelect}></Field>
            </Modal.Body>
            <Modal.Footer>
              <div className="text-right">
                <a className="btn" onClick={handleHideModal}>Đóng</a>
                <button type="submit" onClick={handleSubmit((values) => onSubmit(values, "ADDON_SERVICE_IP_MODIFY"))} className="btn bg-primary" disabled={submitting}>Cập nhật</button>
              </div>
            </Modal.Footer>
          </form>
        </Modal>
      </React.Fragment>
    )
  }
}
const AddonIPFormWrapper = connect(mapState, mapDispatch)(AddonIPForm);

// Form Thay đổi thông tin IP Server
class ServerIPForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ip_server_data: []
    }
  }

  getIPServerList() {
    const {ipProduct} = this.props;
    const product_type = ipProduct.product.product_type;
    const self = this;
    axios({
      method: 'get',
      url: window.api_url + '/admin/api/ip_server/' + getServerIpType(product_type),
      withCredentials: true
    }).then(function (response) {
      if(!response.data.isError) {
        self.setState({
          ip_server_data: response.data.data
        })
      }
    });
  }

  componentDidMount() {
    this.getIPServerList();
  }

  render() {
    const {handleSubmit, ipProduct, submitting, ipOptions, modalConfig, onSubmit, handleHideModal} = this.props;
    const { ip_server_data } = this.state;
    const ip_options = _.map(ip_server_data, (i) => ({label: `${i.ip} ${i.group_name ? i.group_name : ""}`  , value: i.ip }))

     return (
      <React.Fragment>
        <ToastContainer />
        <Modal bsPrefix = "modal" {...modalConfig} dialogClassName="modal-open">
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-sm">Thay Đổi IP Server</Modal.Title>
          </Modal.Header>
          <form>
            <Modal.Body>
              <span>
                IP Server Cũ: <strong>{ipProduct.server_ip_address}</strong>
              </span>
              <Field name="new_ip_server" placeholder="Chọn IP Server mới..." options={ip_options} component={RenderSelect}></Field>
            </Modal.Body>
            <Modal.Footer>
              <div className="text-right">
                <a className="btn" onClick={handleHideModal}>Đóng</a>
                <button type="submit" onClick={handleSubmit((values) => onSubmit(values, "SERVER_IP_MODIFY"))} className="btn bg-primary" disabled={submitting}>Cập nhật</button>
              </div>
            </Modal.Footer>
          </form>
        </Modal>
      </React.Fragment>
    )
  }
}
const ServerIPFormWrapper = connect(mapState, mapDispatch)(ServerIPForm);

// Form thay đổi thông tin cho IP dịch vụ
class ServiceIPForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ip_data: []
    }
  }

  // Lấy đúng danh sách IP
  getIsFreeIpList = () => {
    const self = this;
    axios({
      method: 'get',
      url: window.api_url + '/admin/api/is_free_ip/list',
      withCredentials: true
    }).then(function (response) {
      if(!response.data.isError) {
        self.setState({
          ip_data: response.data.data
        })
      }
    });
  }

  componentDidMount() {
    this.getIsFreeIpList();
  }

  render() {
    const {handleSubmit, ipProduct, submitting, modalConfig, onSubmit, handleHideModal} = this.props;
    const { ip_data } = this.state;
    const ip_options = _.map(ip_data, (i) => ({label: `${i.ip} ${i.group_name ? i.group_name : ""}`  , value: i.ip }))
    const modify_reason_options = [
      { label:"Đổi Sang IP Khác", value:"CHANGE_IP_SERVICE" },
      { label:"Trùng IP", value: "CHANGE_IP_DUPLICATE" }
    ];
     return (
      <React.Fragment>
        <ToastContainer />
        <Modal bsPrefix = "modal" {...modalConfig} dialogClassName="modal-open">
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-sm">Thay Đổi IP Dịch Vụ</Modal.Title>
          </Modal.Header>
          <form>
            <Modal.Body>
              <span>
                IP Cũ: <strong>{ipProduct.ip_address}</strong>
              </span>
              <Field name="new_ip_service" placeholder="Chọn IP mới..." options={ip_options} component={RenderSelect}></Field>
              <label>Lý Do Chuyển Đổi:</label>
              <br/>
              <Field name="modify_reason" options={modify_reason_options} component={RenderRadioCheckBox} />
            </Modal.Body>
            <Modal.Footer>
              <div className="text-right">
                <a className="btn" onClick={handleHideModal}>Đóng</a>
                <button type="submit" onClick={handleSubmit((values) => onSubmit(values, "PARENT_SERVICE_IP_MODIFY"))} className="btn bg-primary">Cập nhật</button>
              </div>
            </Modal.Footer>
          </form>
        </Modal>
      </React.Fragment>
    )
  }
}
const ServiceIPFormWrapper = connect(mapState, mapDispatch)(ServiceIPForm);

class IPModifyModal extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      ip_data: []
    }
  }

  // Rút lại IP
  onRemoveIp = (ip_product_id) => {
    const alert_confirm = window.confirm("Bạn có chắc muốn rút lại IP này !");
    const { onHide, reset, ipProduct } = this.props;
    if(alert_confirm) {
      axios({
        method: 'post',
        url: window.api_url + '/admin/api/service/remove_ip_addon',
        withCredentials: true,
        data: {
          user_product_id: ip_product_id
        }
      }).then(function (response) {
        if(!response.data.isError) {
          onHide();
        }
      });
    }
  }

  onSubmit = (values, modify_type) => { 
    if(modify_type == "ADDON_SERVICE_IP_MODIFY") {
      this.onUpdateIpAddon(values);
    }
    if(modify_type == "SERVER_IP_MODIFY") {
      this.onUpdateIPServer(values);
    }
    if(modify_type == "PARENT_SERVICE_IP_MODIFY") {
      this.onUpdateIPService(values);
    }
  }

  // Thay đổi IP Addon.
  onUpdateIpAddon = (values) => {
    const { onHide, reset, ipProduct } = this.props;
    if(values.new_ip_addon != ipProduct.ip_address) {
      axios({
        method: 'post',
        url: window.api_url + '/admin/api/service/change_ip_addon',
        withCredentials: true,
        data: {
          user_product_id: ipProduct.id,
          new_ip_addon: values.new_ip_addon,
          old_ip_addon: ipProduct.ip_address
        }
      }).then(function (response) {
        if(!response.data.isError) {
          toast.success("Thay đổi IP Thành Công.");
          onHide();
        }else {
          toast.error("Có lỗi trong quá trình thay đổi IP !");
        }
      });
    }
  }

  onUpdateIPServer = (values) => {
    const { onHide, reset, ipProduct } = this.props;
    if(values.new_ip_server != ipProduct.server_ip_address) {
      axios({
        method: 'post',
        url: window.api_url + '/admin/api/service/change_ip_server',
        withCredentials: true,
        data: {
          user_product_id: ipProduct.id,
          new_ip_server: values.new_ip_server,
          old_ip_server: ipProduct.server_ip_address
        }
      }).then(function (response) {
        if(!response.data.isError) {
          toast.info("Thay đổi IP Server Thành Công.");
          onHide();
        }else {
          toast.error("Có lỗi trong quá trình thay đổi IP !");
        }
      });
    }
  }

  onUpdateIPService = (values) => {
    const { onHide, reset, ipProduct } = this.props;
    if(values.new_ip_server != ipProduct.server_ip_address) {
      axios({
        method: 'post',
        url: window.api_url + '/admin/api/service/change_ip_service',
        withCredentials: true,
        data: {
          user_product_id: ipProduct.id,
          new_ip_service: values.new_ip_service,
          modify_reason: values.modify_reason
        }
      }).then(function (response) {
        if(!response.data.isError) {
          toast.info("Thay đổi IP Dịch Vụ Thành Công.");
          onHide();
        }else {
          toast.error("Có lỗi trong quá trình thay đổi IP Dịch Vụ !");
        }
      });
    }
  }

  handleHideModal = () => {
    const { onHide, reset } = this.props;
    reset();
    onHide();
  }

  render() {
    const { title, submitting, handleSubmit, ipProduct, ipType } = this.props;
    const modalConfig = { enforceFocus: false, backdrop: 'static', show: this.props.show, bssize: "medium", onHide: this.props.onHide, submitting: this.props.submitting };
    if(ipType == "ADDON") {
      return <AddonIPFormWrapper onRemoveIp={this.onRemoveIp} handleHideModal={this.handleHideModal} onSubmit={this.onSubmit} handleSubmit={handleSubmit} ipProduct= {ipProduct} submitting={submitting} modalConfig={modalConfig} />
    }
    if(ipType == "SERVER") {
      return <ServerIPFormWrapper handleHideModal={this.handleHideModal} onSubmit={this.onSubmit} handleSubmit={handleSubmit} ipProduct= {ipProduct} submitting={submitting} modalConfig={modalConfig} />
    }
    if(ipType == "SERVICE") {
      return <ServiceIPFormWrapper handleHideModal={this.handleHideModal} onSubmit={this.onSubmit} handleSubmit={handleSubmit} ipProduct= {ipProduct} submitting={submitting} modalConfig={modalConfig} />
    }
  }
}

export default (connect(mapState, mapDispatch)(
  reduxForm({
    form: 'IPModifyModal',
    destroyOnUnmount: true,
    enableReinitialize: true,
    validate
  })(withRouter(IPModifyModal))));
